/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import AccessibilityCss from "components/accessibility/Accessibility.css";
import { isIOS } from "dc-preview-utils/src/Utils/DeviceUtils";

class SkipNav extends Component {
  render() {
    if (this.props.isAccEnabledByDefault) {
      return "";
    }
    const { enableScreenReader = () => {}, shouldFetchAccContent } = this.props;
    let ariaLabel = this.props.enableAccString;
    let isChecked = false;
    if (shouldFetchAccContent) {
      ariaLabel = this.props.enabledAccString;
      isChecked = true;
    }
    let className = AccessibilityCss.elementInvisible;
    if (isIOS()) {
      className = AccessibilityCss.elementInvisibleOpacity;
    }
    return (
      <div>
        <input
          className={className}
          type="checkbox"
          id="accscreen"
          value={ariaLabel}
          onClick={enableScreenReader}
          checked={isChecked}
          aria-disabled={isChecked}
        />
        <label className={className} htmlFor="accscreen">
          {ariaLabel}
        </label>
      </div>
    );
  }
}

export { SkipNav };
